/* @ngInject */
const mySaleForm = (
  toaster,
  $$owner,
  $$sale,
  $$autocomplete,
) => {
  return {
    restrict: 'E',
    scope: {
      mySale: '=',
      myOldValue: '=',
      enableValidator: '=?',
    },
    template: require('./mySaleForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$sale.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: async (scope, element, attrs, ctrl) => {
        try {
          const response = $$owner.request.getAll()
          const salesNumber = $$autocomplete.request.get('number', 'sales')
          scope.owners = (await response).owners
          scope.salesNumber = await salesNumber
        } catch (error) {
          toaster.error(error)
        }
      },
    },
  }
}

export default mySaleForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/directives/forms/mySaleForm.js